import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { GoogleRecaptchaTemplate } from 'common/module/google/recaptcha/template';
import { LoaderComponent } from 'common/module/loader/component';
import { UserForgotPasswordTemplatePropsInterface } from 'common/module/user/forgot-password/template-props.interface';

export const UserForgotPasswordTemplate: FunctionalComponent<UserForgotPasswordTemplatePropsInterface> = (props) => (
  <div className='authentication authentication--forgot-password'>
    <div className='authentication__close-button' onClick={props.onClose}>
      {i18nTranslate('Close')}
    </div>
    <div className='authentication__content'>
      <h2 className='authentication__heading'>{i18nTranslate('Forgot password?')}</h2>
      {props.error && <div className='authentication__error--general'>{props.error}</div>}
      {props.success && (
        <div className='authentication__email-sent'>
          <div className='authentication__email-sent-title'>{i18nTranslate('Email has been sent!')}</div>
          <div className='authentication__email-sent-txt'>
            {i18nTranslate('Please check your email to reset the password')}
          </div>
        </div>
      )}
      <div className='authentication__form'>
        <div className='authentication__input-area'>
          <div className='authentication__input-label'>{i18nTranslate('Enter your email')}</div>
          <input
            type='text'
            className='authentication__input'
            value={props.fields.email}
            onKeyUp={(e) => props.onKeyUpInput(e)}
            onChange={(e) => props.onChangeInput(e, 'email')}
          />
          <div className='authentication__error'>{props.fieldErrors.email}</div>
        </div>

        <div className='authentication__input-area'>
          <GoogleRecaptchaTemplate {...props.captcha} />

          <div className='authentication__error'>{props.fieldErrors.captcha_token}</div>
        </div>

        <div className='authentication__form-submit'>
          <button className='button' onClick={props.onClickResetPassword}>
            {i18nTranslate('Reset password')}
          </button>
        </div>
      </div>
    </div>
    <LoaderComponent isEnabled={props.loaderEnabled} isCentered={true} />
  </div>
);
